import { DepartureCity } from '@ve/types';
import Backbone from 'backbone';

export default function (departureCity: Backbone.Model<DepartureCity>): DepartureCity {
    return {
        id: departureCity?.get('id'),
        name: departureCity?.get('name'),
        countriesWithDirectFlights: departureCity?.get('countriesWithDirectFlights'),
    };
}